import React from 'react';
import EditHikeInfoDialog, {EditHikeInfoDialogProps} from './EditHikeInfoDialog';
import theme from '../../theme';
import fetchUser from '../../utils/gaia/fetchUser';
import {HikeField} from './HikeField';

interface FieldEditButtonProps extends EditHikeInfoDialogProps {
    anchorTitle: string;
    editTitle: string;
}

interface FieldEditButtonState {
    dialogOpen: boolean;
    user: User | undefined;
}

export default class FieldEditButton
    extends React.Component<FieldEditButtonProps, FieldEditButtonState> {

    constructor(props: FieldEditButtonProps) {
        super(props);
        this.state = {
            dialogOpen: false,
            user: undefined,
        };
    }

    async componentDidMount() {
        this.setState({user: await fetchUser()});
    }

    render() {
        return (
            <span style={{verticalAlign: 'top'}}>
                <a style={{marginTop: theme.spacing(2)}}
                    href="#"
                    title={this.props.anchorTitle}
                    onClick={e => { e.preventDefault(); this.toggleState(); }}
                >
                    {this.props.anchorTitle}
                </a>
                <EditHikeInfoDialog
                    afterUpdate={(editedText: HikeField[]) => this.props.afterUpdate(editedText)}
                    regionType={this.props.regionType}
                    originalText={this.props.originalText}
                    onRequestClose={() => this.toggleState()}
                    open={this.state.dialogOpen}
                    initialStaticDescription={this.props.initialStaticDescription}
                    regionId={this.props.regionId}
                    title={this.props.editTitle}
                />
            </span>
        );
    }

    toggleState() {
        if (this.state.user && (!this.state.user.email || !this.state.user.email.length)) {
            window.location.href = '/register/?next=' + window.location.pathname;
            return;
        }
        this.setState({dialogOpen: !this.state.dialogOpen});
    }

}
